import { type StandardApplicationModuleSpecsFragment } from '../../../../api/fragments/StandardApplicationModuleSpecs';
import FinanceProductAssignments from './FinanceProductAssignments';
import StandardApplicationModuleMainDetails from './StandardApplicationModuleMainDetails';
import { type EditMode, HeaderTabs } from './type';
import VehicleAssignments from './VehicleAssignments';

export type StandardApplicationModuleDetailsInnerProps = {
    activeTab: HeaderTabs;
    module: StandardApplicationModuleSpecsFragment;
    editMode: EditMode;
    setEditMode: (value: EditMode) => void;
};

const StandardApplicationModuleDetailsInner = ({
    activeTab,
    module,
    editMode,
    setEditMode,
}: StandardApplicationModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.Vehicles:
            return <VehicleAssignments module={module} />;

        case HeaderTabs.FinanceProducts:
            return <FinanceProductAssignments module={module} />;

        case HeaderTabs.ModuleDetails:
            return (
                <StandardApplicationModuleMainDetails editMode={editMode} module={module} setEditMode={setEditMode} />
            );

        default:
            return null;
    }
};

export default StandardApplicationModuleDetailsInner;
